var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { prop } from 'ramda';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { backendClientFactory } from '../../apiClient/backend-api/backendClient';
import { componentMessages } from '../../component-translations';
import SingleAutocomplete from '../Autocomplete/SingleAutocomplete';
import { useUserState } from '../User/UserContext';
export const LocationAutocomplete = (props) => {
    const userState = useUserState();
    const api = backendClientFactory(userState.authProvider.getToken);
    const { formatMessage } = useIntl();
    const { initialValue, className, onChange, loadingText = formatMessage(componentMessages['autocomplete.location.loading']), noResultsText = formatMessage(componentMessages['autocomplete.location.noResults']), moreResultsText = formatMessage(componentMessages['autocomplete.location.tooManyResults']), placeholder = formatMessage(componentMessages['autocomplete.location.placeholder']), label = formatMessage(componentMessages['autocomplete.location.label']), fullWidth } = props;
    const getOptions = useCallback((term = '', limit) => __awaiter(void 0, void 0, void 0, function* () {
        return api.getLocations(term, limit)
            .then((locations) => {
            return locations
                .map((l) => ({
                code: l.code,
                description: l.breadcrumbs.map(prop('name')).join(' / '),
                name: l.name
            }));
        });
    }), [api]);
    return (React.createElement(SingleAutocomplete, { fullWidth: fullWidth, initialValue: initialValue, onChange: onChange, getOptions: getOptions, className: className, loadingText: loadingText, noResultsText: noResultsText, moreResultsText: moreResultsText, label: label, placeholder: placeholder }));
};
export default LocationAutocomplete;
//# sourceMappingURL=LocationAutocomplete.js.map